module.exports = __webpack_public_path__ + "img/Stab_S2.92f5fd7a.svg";